import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Fonction pour détecter la langue depuis l'URL
const detectLanguageFromURL = () => {
  if (typeof window !== 'undefined') {
    const path = window.location.pathname;
    if (path.startsWith('/en/')) {
      return 'en';
    } else if (path.startsWith('/fr/')) {
      return 'fr';
    }
  }
  return 'fr'; // Par défaut
};

const resources = {
  fr: {
    translation: {
      // Navigation
      'nav.home': 'Accueil',
      'nav.discover': 'Nous decouvrir',
      'nav.about': 'A-propos',
      'nav.mission': 'Notre Mission',
      'nav.history': 'Notre Histoire',
      'nav.team': 'Notre Équipe',
      'nav.status': 'Statuts',
      'nav.actions': 'Nos Actions',
      'nav.actions.water': 'Eau et assainissement',
      'nav.actions.health': 'Santé et sécurité alimentaire',
      'nav.actions.social': 'Action sociale et inclusion',
      'nav.actions.environment': 'Protection de l\'environnement',
      'nav.actions.life': 'Amélioration du cadre de vie',
      'nav.health': 'Santé & Sécurité alimentaire',
      'nav.education': 'Éducation & Environnement',
      'nav.water': 'Accès à l\'eau potable',
      'nav.development': 'Développement',
      'nav.integration': 'Integration communautaire',
      'nav.news': 'Actualités',
      'nav.documents': 'Documents',
      'nav.projects': 'Projets',
      'nav.publications': 'Publications',
      'nav.career': 'Carrière',
      'nav.contacts': 'Contacts',
      'nav.donate': 'Faire un don',
      'nav.search': 'Rechercher...',
      'nav.topBanner': 'Action-Humanitaire Bénin : Cinq ans d\'action humanitaire au Bénin',
      
      // Hero Section
      'hero.error': 'Impossible de charger les slides',
      'hero.defaultTitle': 'Action-Humanitaire Bénin',
      'hero.defaultDescription': 'Nous œuvrons pour le bien-être des communautés vulnérables.',
      'hero.loadingError': 'Erreur de chargement',
      'hero.noSlides': 'Aucun slide disponible',
      'hero.slidesComingSoon': 'Les slides seront bientôt disponibles',
      'hero.displayError': 'Erreur d\'affichage',
      'hero.cannotLoadSlide': 'Impossible de charger le slide actuel',
      'hero.learnMore': 'En savoir plus',
      'hero.retry': 'Réessayer',
      'hero.slide': 'Slide',
      
      // News Section
      'news.title': 'NOS ACTUALITÉS',
      'news.subtitle': 'Découvrez nos dernières nouvelles, actions et initiatives pour transformer les communautés',
      'news.searchPlaceholder': 'Rechercher dans les articles...',
      'news.allCategories': 'Toutes les catégories',
      'news.sortLatest': 'Plus récents',
      'news.sortOldest': 'Plus anciens',
      'news.sortTitle': 'Par titre',
      'news.resultsCount': '{{count}} article(s) trouvé(s)',
      'news.forQuery': 'pour la recherche',
      'news.inCategory': 'dans la catégorie',
      'news.noArticlesFound': 'Aucun article trouvé',
      'news.noArticlesDesc': 'Essayez de modifier vos critères de recherche ou de supprimer les filtres',
      'news.clearFilters': 'Effacer les filtres',
      'news.readMore': 'Lire la suite',
      'news.previous': 'Précédent',
      'news.next': 'Suivant',
      'news.noDescription': 'Aucune description disponible',
      'news.oddError': 'Erreur de chargement',
      'news.oddErrorDesc': 'Section ODD non disponible',
      'news.retry': 'Réessayer',
      
      // Article Detail Page
      'article.backToNews': 'Retour aux actualités',
      'article.publishedOn': 'Publié le',
      'article.by': 'Par',
      'article.like': 'J\'aime',
      'article.liked': 'Aimé',
      'article.bookmark': 'Sauvegarder',
      'article.bookmarked': 'Sauvegardé',
      'article.share': 'Partager',
      'article.shareFacebook': 'Facebook',
      'article.shareTwitter': 'Twitter',
      'article.shareLinkedin': 'LinkedIn',
      'article.shareEmail': 'Email',
      'article.copyLink': 'Copier le lien',
      'article.linkCopied': 'Lien copié dans le presse-papiers !',
      'article.comments': 'commentaire',
      'article.commentsPlural': 'commentaires',
      'article.addComment': 'Ajouter un commentaire',
      'article.fullName': 'Nom complet',
      'article.email': 'Email',
      'article.comment': 'Commentaire',
      'article.commentPlaceholder': 'Partagez votre avis sur cet article...',
      'article.cancel': 'Annuler',
      'article.publishComment': 'Publier le commentaire',
      'article.sending': 'Envoi...',
      'article.commentSuccess': 'Votre commentaire a été envoyé avec succès. Il sera visible après modération.',
      'article.commentError': 'Erreur lors de l\'envoi du commentaire',
      'article.noComments': 'Aucun commentaire pour le moment.',
      'article.beFirstComment': 'Soyez le premier à commenter cet article !',
      'article.articleNotFound': 'Article non trouvé',
      'article.notFoundDesc': 'L\'article que vous recherchez n\'existe pas ou a été supprimé.',
      
      // Projects Section
      'projects.title': 'Nos Domaines d\'Intervention',
      'projects.subtitle': 'Découvrez nos principaux axes d\'intervention pour transformer les communautés',
      'projects.water': 'Accès à l\'eau potable',
      'projects.waterDesc': 'Forage et distribution d\'eau saine pour les communautés rurales et urbaines défavorisées',
      'projects.health': 'Santé communautaire',
      'projects.healthDesc': 'Soins de base, sensibilisation et accompagnement des populations vulnérables',
      'projects.social': 'Développement social',
      'projects.socialDesc': 'Intégration et amélioration des conditions de vie des communautés locales',
      'projects.active': 'Projet actif',
      'projects.severalWells': 'plusieurs forages réalisés',
      'projects.severalBeneficiaries': 'plusieurs bénéficiaires',
      'projects.severalActive': 'plusieurs projets actifs',
      'projects.learnMore': 'En savoir plus',
      'projects.viewAll': 'Voir tous nos projets',
      'projects.loadingError': 'Erreur de chargement',
      'projects.noProjects': 'Aucun projet disponible',
      'projects.noProjectsDesc': 'Les projets seront bientôt disponibles',
      
      // InFocus Section
      'infocus.title': 'À PROPOS DE NOUS',
      'infocus.subtitle': 'Découvrez notre organisation, notre vision et nos plans stratégiques pour transformer les communautés',
      'infocus.focus': 'Focus',
      'infocus.learnMore': 'En savoir plus',
      'infocus.joinMission': 'Rejoignez notre mission',
      'infocus.joinDesc': 'Découvrez comment contribuer à notre action humanitaire',
      'infocus.contactUs': 'Nous contacter',
      'infocus.loadingError': 'Erreur de chargement',
      'infocus.noItems': 'Aucun élément focus disponible',
      'infocus.noItemsDesc': 'Les éléments seront bientôt disponibles',
      'infocus.retry': 'Réessayer',
      'infocus.enlargedView': 'Vue agrandie',
      
      // Strategy Section
      'strategy.title': 'NOTRE STRATÉGIE',
      'strategy.subtitle': 'Découvrez nos axes stratégiques pour transformer durablement les communautés et créer un impact positif',
      'strategy.recentArticlesTitle': 'NOS ARTICLES RÉCENTS',
      'strategy.recentArticlesSubtitle': 'Découvrez nos derniers articles sur le développement durable et l\'action humanitaire',
      'strategy.loadingError': 'Erreur de chargement',
      'strategy.noStrategies': 'Aucune stratégie disponible',
      'strategy.noStrategiesDesc': 'Les stratégies seront bientôt disponibles',
      'strategy.retry': 'Réessayer',
      'strategy.noArticles': 'Aucun article disponible',
      'strategy.noArticlesDesc': 'Les articles seront bientôt disponibles',
      'strategy.noDescription': 'Aucune description disponible',
      'strategy.readMore': 'Savoir plus',
      
      // Mission Page
      'mission.hero.title': 'NOTRE MISSION',
      'mission.hero.subtitle': 'Agir pour transformer les communautés et bâtir un avenir durable',
      'mission.context.title': 'Contexte Actuel',
      'mission.vision.title': 'Vision Transformative',
      'mission.pillars.title': 'Les 5 Piliers d\'Action',
      'mission.strategy.title': 'Stratégie Opérationnelle',
      'mission.changeAxes.title': 'Axes du Changement',
      'mission.catalysts.title': 'Catalyseurs de Progrès',
      'mission.objective2026.title': 'Objectif 2026',
      'mission.loading': 'Chargement...',
      'mission.error.title': 'Erreur de chargement',
      'mission.error.retry': 'Réessayer',

      
      // Footer
      'footer.sectorsTitle': 'Sectors',
      'footer.sector1': 'Agriculture & Développement rural',
      'footer.sector2': 'Changement climatique',
      'footer.sector3': 'Éducation & Formation',
      'footer.sector4': 'Santé & Bien-être',
      'footer.sector5': 'Énergie',
      'footer.topicsTitle': 'Topics',
      'footer.topic1': 'Société civile',
      'footer.topic2': 'Évaluation indépendante',
      'footer.topic3': 'Mécanisme de recours',
      'footer.topic4': 'Résilience & Innovation',
      'footer.micrositesTitle': 'Nos microsites',
      'footer.microsite1': 'Réunions Annuelles',
      'footer.microsite2': 'Conférence Économique',
      'footer.microsite3': 'Forum Humanitaire',
      'footer.connectTitle': 'Connectez-vous avec nous',
      'footer.resourcesTitle': 'Ressources pour',
      'footer.resource1': 'Investisseurs',
      'footer.resource2': 'Académie',
      'footer.resource3': 'Opportunités',
      'footer.resource4': 'Newsletter',
      'footer.legal1': 'Conditions d\'utilisation',
      'footer.legal2': 'Cookies & Politique de confidentialité',
      'footer.legal3': 'Plan du site',
      'footer.legal4': 'Recherche',
      'footer.legal5': 'Divulgation et accès à l\'information',
      'footer.legal6': 'Blogs',
      'footer.legal7': 'Glossaire',
      'footer.copyright': '© 2025 Action-Humanitaire Bénin',
      'footer.scrollToTop': 'Retour en haut',
      
      // Common
      'common.loading': 'Chargement...',
      'common.error': 'Erreur',
      'common.retry': 'Réessayer',
      'common.learnMore': 'En savoir plus',
      'common.contact': 'Contact',
      'common.about': 'À propos',
      'common.mission': 'Mission',

      // Contact page
      'contact.title': 'CONTACTEZ-NOUS',
      'contact.subtitle': 'Nous sommes là pour vous écouter et répondre à vos questions',
      'contact.coordinates.title': 'Nos Coordonnées',
      'contact.coordinates.address.title': 'Notre Adresse',
      'contact.coordinates.address.street': 'Avenue PK3 Rue N\'venamede',
      'contact.coordinates.address.city': 'Cotonou, Bénin',
      'contact.coordinates.phone.title': 'Téléphone',
      'contact.coordinates.phone.number': '+229 01 55 07 81 81',
      'contact.coordinates.email.title': 'Email',
      'contact.coordinates.email.address': 'contact@ahbenin.org',
      'contact.coordinates.hours.title': 'Heures d\'ouverture',
      'contact.coordinates.hours.weekdays': 'Lundi - Vendredi',
      'contact.coordinates.hours.weekdaysTime': '8h00 - 18h00',
      'contact.coordinates.hours.saturday': 'Samedi',
      'contact.coordinates.hours.saturdayTime': '9h00 - 13h00',
      'contact.coordinates.map.title': 'Nous Localiser',
      'contact.form.title': 'Envoyez-nous un message',
      'contact.form.name.label': 'Nom complet',
      'contact.form.name.placeholder': 'Votre nom et prénom',
      'contact.form.email.label': 'Email',
      'contact.form.email.placeholder': 'votre.email@exemple.com',
      'contact.form.subject.label': 'Sujet',
      'contact.form.subject.placeholder': 'Objet de votre message',
      'contact.form.message.label': 'Message',
      'contact.form.message.placeholder': 'Décrivez votre demande en détail...',
      'contact.form.submit': 'Envoyer le message',

      // About page
      'about.hero.title': 'NOTRE ENGAGEMENT',
      'about.hero.subtitle': 'Transformer les communautés à travers l\'action humanitaire et le développement durable',
      'about.preface.title': 'Avant-propos',
      'about.vision.title': 'Notre Vision',
      'about.strategy.title': 'Plans stratégiques 2023-2026',
      'about.strategy.subtitle': 'Un avenir durable et inclusif pour tous',
      'about.objectives.title': 'Nos Objectifs - The High 5',
      'about.approaches.title': 'Nos Approches',
      'about.changeAxes.title': 'Axes du Changement',
      'about.catalysts.title': 'Catalyseurs',
      
      // Partners Section
      'partners.title': 'NOS PARTENAIRES',
      'partners.subtitle': 'Ensemble pour un impact durable et une transformation positive des communautés',
      'partners.loadingError': 'Erreur lors du chargement des partenaires',
      'partners.cta.title': 'Devenez Partenaire',
      'partners.cta.description': 'Rejoignez notre réseau de partenaires et participez à nos actions humanitaires pour créer un impact durable.',
      'partners.cta.button': 'Nous Contacter'
    }
  },
  en: {
    translation: {
      // Navigation
      'nav.home': 'Home',
      'nav.discover': 'Discover Us',
      'nav.about': 'About',
      'nav.mission': 'Our Mission',
      'nav.history': 'Our History',
      'nav.team': 'Our Team',
      'nav.status': 'Statutes',
      'nav.actions': 'Our Actions',
      'nav.actions.water': 'Water and Sanitation',
      'nav.actions.health': 'Health and Food Security',
      'nav.actions.social': 'Social Action and Inclusion',
      'nav.actions.environment': 'Environmental Protection',
      'nav.actions.life': 'Improving Living Conditions',
      'nav.health': 'Health & Food Security',
      'nav.education': 'Education & Environment',
      'nav.water': 'Access to Clean Water',
      'nav.development': 'Development',
      'nav.integration': 'Community Integration',
      'nav.news': 'News',
      'nav.documents': 'Documents',
      'nav.projects': 'Projects',
      'nav.publications': 'Publications',
      'nav.career': 'Career',
      'nav.contacts': 'Contacts',
      'nav.donate': 'Make a Donation',
      'nav.search': 'Search...',
      'nav.topBanner': 'Action-Humanitaire Bénin: Five years of humanitarian action in Benin',
      
      // Hero Section
      'hero.error': 'Unable to load slides',
      'hero.defaultTitle': 'Action-Humanitaire Bénin',
      'hero.defaultDescription': 'We work for the well-being of vulnerable communities.',
      'hero.loadingError': 'Loading Error',
      'hero.noSlides': 'No slides available',
      'hero.slidesComingSoon': 'Slides will be available soon',
      'hero.displayError': 'Display Error',
      'hero.cannotLoadSlide': 'Unable to load current slide',
      'hero.learnMore': 'Learn More',
      'hero.retry': 'Retry',
      'hero.slide': 'Slide',
      
      // News Section
      'news.title': 'OUR NEWS',
      'news.subtitle': 'Discover our latest news, actions and initiatives to transform communities',
      'news.searchPlaceholder': 'Search in articles...',
      'news.allCategories': 'All categories',
      'news.sortLatest': 'Latest',
      'news.sortOldest': 'Oldest',
      'news.sortTitle': 'By title',
      'news.resultsCount': '{{count}} article(s) found',
      'news.forQuery': 'for search',
      'news.inCategory': 'in category',
      'news.noArticlesFound': 'No articles found',
      'news.noArticlesDesc': 'Try modifying your search criteria or clearing the filters',
      'news.clearFilters': 'Clear filters',
      'news.readMore': 'Read more',
      'news.previous': 'Previous',
      'news.next': 'Next',
      'news.noDescription': 'No description available',
      'news.oddError': 'Loading Error',
      'news.oddErrorDesc': 'ODD section not available',
      'news.retry': 'Retry',
      
      // Article Detail Page
      'article.backToNews': 'Back to news',
      'article.publishedOn': 'Published on',
      'article.by': 'By',
      'article.like': 'Like',
      'article.liked': 'Liked',
      'article.bookmark': 'Bookmark',
      'article.bookmarked': 'Bookmarked',
      'article.share': 'Share',
      'article.shareFacebook': 'Facebook',
      'article.shareTwitter': 'Twitter',
      'article.shareLinkedin': 'LinkedIn',
      'article.shareEmail': 'Email',
      'article.copyLink': 'Copy link',
      'article.linkCopied': 'Link copied to clipboard!',
      'article.comments': 'comment',
      'article.commentsPlural': 'comments',
      'article.addComment': 'Add a comment',
      'article.fullName': 'Full name',
      'article.email': 'Email',
      'article.comment': 'Comment',
      'article.commentPlaceholder': 'Share your opinion on this article...',
      'article.cancel': 'Cancel',
      'article.publishComment': 'Publish comment',
      'article.sending': 'Sending...',
      'article.commentSuccess': 'Your comment has been sent successfully. It will be visible after moderation.',
      'article.commentError': 'Error sending comment',
      'article.noComments': 'No comments yet.',
      'article.beFirstComment': 'Be the first to comment on this article!',
      'article.articleNotFound': 'Article not found',
      'article.notFoundDesc': 'The article you are looking for does not exist or has been deleted.',
      
      // Projects Section
      'projects.title': 'Our Areas of Intervention',
      'projects.subtitle': 'Discover our main areas of intervention to transform communities',
      'projects.water': 'Access to Clean Water',
      'projects.waterDesc': 'Drilling and distribution of clean water for rural and urban disadvantaged communities',
      'projects.health': 'Community Health',
      'projects.healthDesc': 'Basic care, awareness and support for vulnerable populations',
      'projects.social': 'Social Development',
      'projects.socialDesc': 'Integration and improvement of living conditions for local communities',
      'projects.active': 'Active Project',
      'projects.severalWells': 'several wells completed',
      'projects.severalBeneficiaries': 'several beneficiaries',
      'projects.severalActive': 'several active projects',
      'projects.learnMore': 'Learn More',
      'projects.viewAll': 'View All Our Projects',
      'projects.loadingError': 'Loading Error',
      'projects.noProjects': 'No projects available',
      'projects.noProjectsDesc': 'Projects will be available soon',
      
      // InFocus Section
      'infocus.title': 'ABOUT US',
      'infocus.subtitle': 'Discover our organization, our vision and our strategic plans to transform communities',
      'infocus.focus': 'Focus',
      'infocus.learnMore': 'Learn More',
      'infocus.joinMission': 'Join Our Mission',
      'infocus.joinDesc': 'Discover how to contribute to our humanitarian action',
      'infocus.contactUs': 'Contact Us',
      'infocus.loadingError': 'Loading Error',
      'infocus.noItems': 'No focus items available',
      'infocus.noItemsDesc': 'Items will be available soon',
      'infocus.retry': 'Retry',
      'infocus.enlargedView': 'Enlarged view',
      
      // Strategy Section
      'strategy.title': 'OUR STRATEGY',
      'strategy.subtitle': 'Discover our strategic axes to sustainably transform communities and create positive impact',
      'strategy.recentArticlesTitle': 'OUR RECENT ARTICLES',
      'strategy.recentArticlesSubtitle': 'Discover our latest articles on sustainable development and humanitarian action',
      'strategy.loadingError': 'Loading Error',
      'strategy.noStrategies': 'No strategies available',
      'strategy.noStrategiesDesc': 'Strategies will be available soon',
      'strategy.retry': 'Retry',
      'strategy.noArticles': 'No articles available',
      'strategy.noArticlesDesc': 'Articles will be available soon',
      'strategy.noDescription': 'No description available',
      'strategy.readMore': 'Read More',
      
      // Mission Page
      'mission.hero.title': 'OUR MISSION',
      'mission.hero.subtitle': 'Acting to transform communities and build a sustainable future',
      'mission.context.title': 'Current Context',
      'mission.vision.title': 'Transformative Vision',
      'mission.pillars.title': 'The 5 Pillars of Action',
      'mission.strategy.title': 'Operational Strategy',
      'mission.changeAxes.title': 'Change Axes',
      'mission.catalysts.title': 'Progress Catalysts',
      'mission.objective2026.title': 'Objective 2026',
      'mission.loading': 'Loading...',
      'mission.error.title': 'Loading Error',
      'mission.error.retry': 'Retry',

      
      // Footer
      'footer.sectorsTitle': 'Sectors',
      'footer.sector1': 'Agriculture & Rural Development',
      'footer.sector2': 'Climate Change',
      'footer.sector3': 'Education & Training',
      'footer.sector4': 'Health & Well-being',
      'footer.sector5': 'Energy',
      'footer.topicsTitle': 'Topics',
      'footer.topic1': 'Civil Society',
      'footer.topic2': 'Independent Evaluation',
      'footer.topic3': 'Recourse Mechanism',
      'footer.topic4': 'Resilience & Innovation',
      'footer.micrositesTitle': 'Our Microsites',
      'footer.microsite1': 'Annual Meetings',
      'footer.microsite2': 'Economic Conference',
      'footer.microsite3': 'Humanitarian Forum',
      'footer.connectTitle': 'Connect with Us',
      'footer.resourcesTitle': 'Resources for',
      'footer.resource1': 'Investors',
      'footer.resource2': 'Academy',
      'footer.resource3': 'Opportunities',
      'footer.resource4': 'Newsletter',
      'footer.legal1': 'Terms of Use',
      'footer.legal2': 'Cookies & Privacy Policy',
      'footer.legal3': 'Sitemap',
      'footer.legal4': 'Search',
      'footer.legal5': 'Disclosure and Access to Information',
      'footer.legal6': 'Blogs',
      'footer.legal7': 'Glossary',
      'footer.copyright': '© 2025 Action-Humanitaire Bénin',
      'footer.scrollToTop': 'Back to top',
      
      // Common
      'common.loading': 'Loading...',
      'common.error': 'Error',
      'common.retry': 'Retry',
      'common.learnMore': 'Learn More',
      'common.contact': 'Contact',
      'common.about': 'About',
      'common.mission': 'Mission',

      // Contact page
      'contact.title': 'CONTACT US',
      'contact.subtitle': 'We are here to listen to you and answer your questions',
      'contact.coordinates.title': 'Our Coordinates',
      'contact.coordinates.address.title': 'Our Address',
      'contact.coordinates.address.street': 'Avenue PK3 Rue N\'venamede',
      'contact.coordinates.address.city': 'Cotonou, Benin',
      'contact.coordinates.phone.title': 'Phone',
      'contact.coordinates.phone.number': '+229 01 55 07 81 81',
      'contact.coordinates.email.title': 'Email',
      'contact.coordinates.email.address': 'contact@ahbenin.org',
      'contact.coordinates.hours.title': 'Opening Hours',
      'contact.coordinates.hours.weekdays': 'Monday - Friday',
      'contact.coordinates.hours.weekdaysTime': '8:00 - 18:00',
      'contact.coordinates.hours.saturday': 'Saturday',
      'contact.coordinates.hours.saturdayTime': '9:00 - 13:00',
      'contact.coordinates.map.title': 'Locate Us',
      'contact.form.title': 'Send us a message',
      'contact.form.name.label': 'Full Name',
      'contact.form.name.placeholder': 'Your first and last name',
      'contact.form.email.label': 'Email',
      'contact.form.email.placeholder': 'your.email@example.com',
      'contact.form.subject.label': 'Subject',
      'contact.form.subject.placeholder': 'Subject of your message',
      'contact.form.message.label': 'Message',
      'contact.form.message.placeholder': 'Describe your request in detail...',
      'contact.form.submit': 'Send Message',

      // About page
      'about.hero.title': 'OUR COMMITMENT',
      'about.hero.subtitle': 'Transform communities through humanitarian action and sustainable development',
      'about.preface.title': 'Preface',
      'about.vision.title': 'Our Vision',
      'about.strategy.title': 'Strategic Plans 2023-2026',
      'about.strategy.subtitle': 'A sustainable and inclusive future for all',
      'about.objectives.title': 'Our Objectives - The High 5',
      'about.approaches.title': 'Our Approaches',
      'about.changeAxes.title': 'Change Axes',
      'about.catalysts.title': 'Catalysts',
      
      // Partners Section
      'partners.title': 'OUR PARTNERS',
      'partners.subtitle': 'Together for sustainable impact and positive transformation of communities',
      'partners.loadingError': 'Error loading partners',
      'partners.cta.title': 'Become a Partner',
      'partners.cta.description': 'Join our network of partners and participate in our humanitarian actions to create lasting impact.',
      'partners.cta.button': 'Contact Us'
    }
  }
};

// Initialisation synchrone
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: detectLanguageFromURL(), // Utiliser la langue détectée depuis l'URL
    fallbackLng: 'fr',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      // Ne pas détecter automatiquement la langue du navigateur
      // pour éviter les conflits avec l'URL
      checkWhitelist: true,
    },
    react: {
      useSuspense: false,
    },
  });

// Synchroniser la langue avec l'URL au démarrage
const initialLang = detectLanguageFromURL();
if (initialLang && initialLang !== i18n.language) {
  console.log(`🚀 Initialisation i18n: URL=${initialLang}, i18n=${i18n.language}`);
  i18n.changeLanguage(initialLang);
  localStorage.setItem('i18nextLng', initialLang);
}

export default i18n;
